<template>
    <div class="class-student-list">
      <h3 style="display: inline-block;">本节课学员 （{{ studentList.length }}）</h3>
      <span style="display: inline-block;">
          <!-- <a-button @click="selectAll" size="small">全选</a-button>
          <a-divider type="vertical"></a-divider>
          <a-button @click="cancelSelectAll" size="small">全不选</a-button>
          <a-divider type="vertical"></a-divider> -->
          <a-button @click="handleBatchSign" size="small">批量签到 ({{ studentList.length - signList.length }})</a-button>
          <a-divider type="vertical"></a-divider>
          <a-input addoneBefore="本节消耗课时" v-model="courseHours" min="0"></a-input>

      </span>
      <a-divider></a-divider>
      <a-spin v-if="loading">加载中……</a-spin>
      <a-row  :gutter="[40, 10]">
        <a-col  v-for="(s, i) in studentList" :key="i">
          <span
            >{{ s.username }} | {{ s.realname }} | {{ s.integral
            }}{{ $store.getters.tenantInfo.coinName }}</span
          >
          <span style="float: right">
            <a-popconfirm v-if="signList.includes(s.id)" title="确定取消签到吗?" @confirm="() => handleCancelSign(s.id)">
              <a-button icon="check" type="danger" size="small">已出勤</a-button>
            </a-popconfirm>
            <a-button v-else icon="check" type="primary" size="small" @click="handleSign(s.id)">签到</a-button>
            <a-divider type="vertical"></a-divider>
            <!-- <a-button icon="dollar" size="small" @click="handleIntegral(s.id)">{{
              $store.getters.tenantInfo.coinName
            }}</a-button> -->
            <a  @click="handleIntegral(s.id)"><a-icon type="dollar" /></a>
            <a-divider type="vertical"></a-divider>
            <router-link :to="getReviewUrl(s.id)"><a-icon type="camera"/></router-link>
          </span>
        </a-col>
      </a-row>
  
      <sys-user-integral-modal
        ref="integralModal"
        @ok="integralModalFormOk"
      ></sys-user-integral-modal>
    </div>
  </template>
  
  <script>
  import Vue from 'vue'
  import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
  import { getAction, postAction } from "@/api/manage";
  import SysUserIntegralModal from "@/components/user/SysUserIntegralModal";
  import QrCode from '@/components/tools/QrCode'
  export default {
    name: "ClassStudentListModal",
    components: {
      SysUserIntegralModal,
      qrcode: QrCode,
    },
    data() {
      return {
        visible: false,
        loading: false,
        departId: "",
        courseId: "",
        unitId: "",
        unitInfo: "",
        courseHours: undefined,
        studentList: [],
        signList: [],
        checkedList: [],
        url:{
          reviewUrl: '/teacherPhotoReview',
        }
      };
    },
    watch:{
      signList:{
        immediate: false,
        deep: true,
          handler() {
            this.handleSignListChange()
          }
      }
    },
    created() {
        this.departId = this.$route.query.departId;
        this.courseId = this.$route.query.courseId;
        this.unitId = this.$route.query.unitId;
        this.getDepartStudent();
        if(!this.unitInfo){
          this.getUnitInfo()
        }
    },
    methods: {
      getUnitInfo(){
        getAction("/teaching/teachingCourseUnit/queryById", {id: this.unitId}).then(res=>{
          if(res.success){
            this.unitInfo = res.result
            if(this.unitInfo.courseHour){
              this.courseHours = this.unitInfo.courseHour
            }
          }
        })
    },

      getDepartStudent() {
        this.loading = true;
        getAction("/sys/user/departUserList", {
          depId: this.departId,
          userIdentity: 1,
          pageSize: 999,
        })
          .then((res) => {
            if (res.success) {
              this.studentList = res.result.records;
            } else {
              this.$message.info(res.message);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      },
      getClassroomSignList() {
        this.signList = []
        getAction("/teaching/teachingStudyLog/classroomSignList", {
          departId: this.departId,
          courseId: this.courseId,
          unitId: this.unitId,
        })
          .then((res) => {
            if (res.success) {3
              for(let i=0; i<res.result.length; i++){
                  this.signList.push(res.result[i].userId)
              }
            } else {
              this.$message.info(res.message);
            }
          })
          .finally(() => {
          });
      },
      selectAll(){
  
      },
      cancelSelectAll(){
  
      },
      handleBatchSign(){
          if(this.studentList.length == this.signList.length){
              this.$message.info('没有可以签到的学生')
              return
          }
          if(!this.courseHours){
            this.$message.error('请输入消耗课时')
            return
          }
          for(let i=0; i < this.studentList.length; i++){
              let stuId = this.studentList[i].id
              if(this.signList.includes(stuId)) continue;
              this.handleSign(stuId)
          }
      },
      handleSign(userId) {
        if(!this.courseHours){
          this.$message.error('请输入消耗课时')
          return
        }
        getAction("/teaching/teachingStudyLog/classroomSignByTeacher", {
          userId: userId,
          departId: this.departId,
          courseId: this.courseId,
          unitId: this.unitId,
          courseHours: this.courseHours
        }).then((res) => {
          if(res.success){
              this.signList.push(userId)
          }
          this.$message.info(res.message);
        });
      },
      handleCancelSign(userId) {
        getAction("/teaching/teachingStudyLog/classroomCancelSignByTeacher", {
          userId: userId,
          departId: this.departId,
          courseId: this.courseId,
          unitId: this.unitId,
        }).then((res) => {
          if(res.success){
              this.signList = this.signList.filter(item => item != userId)
          }
          this.$message.info(res.message);
        });
      },
      handleIntegral(userId) {
        this.$refs.integralModal.edit({ userId: userId, unitId: this.unitId });
      },
      integralModalFormOk() {
        this.getDepartStudent();
      },
      handleSignListChange(){
        console.log("handleSignListChange", this.signList);
        
        this.$emit('signListChange', this.signList)
      },
    getReviewUrl(userId){
    let token = Vue.ls.get(ACCESS_TOKEN);
    return `${this.url.reviewUrl}?departId=${this.departId}&courseId=${this.courseId}&userId=${userId}&unitId=${this.unitId}&token=${token}`
    },  
      close() {
        this.visible = false;
      },
    },
  };
  </script>
  
<style scoped>
  .class-student-list{
    padding: 12px;
  }
</style>